import posthog from 'posthog-js';
import type { CaptureResult } from 'posthog-js';
import { supabase } from './supabase';
import { redactAuthUrl } from './redactAuthUrl';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

function redactProps(props: Record<string, unknown> | undefined) {
  if (!props) return;
  for (const [key, value] of Object.entries(props)) {
    if (typeof value === 'string') props[key] = redactAuthUrl(value);
  }
}

function redactEvent(event: CaptureResult | null): CaptureResult | null {
  if (!event) return event;
  redactProps(event.properties);
  redactProps(event.$set);
  redactProps(event.$set_once);
  return event;
}

// PostHog starts only after Supabase has read the auth redirect and cleared the
// tokens from the URL, so pageviews and the replay's first snapshot never see
// them (#332). before_send is the backstop for anything captured later.
export function initPostHog() {
  if (!POSTHOG_KEY) return;
  supabase.auth.initialize().finally(() => {
    // A redirect Supabase failed to consume keeps its fragment; drop it.
    if (window.location.hash !== redactAuthUrl(window.location.hash)) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      persistence: 'localStorage',
      capture_exceptions: true,
      before_send: redactEvent,
      session_recording: {
        maskCapturedNetworkRequestFn: (request) => ({ ...request, name: redactAuthUrl(request.name) }),
      },
    });
  });
}

export { posthog };
